import axios from 'axios';

const get = async (params) =>{
    const response = await axios.get('/reservations/vue/resources/package_addons',{params});
    return response.data.data;
}

export default get;
